import styled from '@emotion/styled';
import { TableHead, TableRow, TableRowProps } from '@mui/material';
import { colors } from 'Constants/Colors';

export const GenericTableHead = styled(TableHead)`
  & .MuiTableCell-root {
    font-weight: 600;
    font-family: metropolis;
  }
`;

export const SpacedTableRow = styled(TableRow)`
  border-bottom: 8px solid transparent;
`;

interface GenericTableRowProps extends TableRowProps {
  isClickable?: boolean;
}

export const GenericTableRow = styled(TableRow)<GenericTableRowProps>`
  background-color: white;
  position: relative;
  cursor: ${({ isClickable }) => (isClickable ? 'pointer' : 'default')};
  transition: ${({ isClickable }) =>
    isClickable
      ? 'transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.3s cubic-bezier(0.34, 1.56, 0.64, 1), background-color 0.3s ease'
      : 'none'};
  transform-origin: center;

  & td {
    background: transparent;
    font-weight: 500;
    transition: background-color 0.2s ease;
  }

  &:hover {
    ${({ isClickable }) =>
      isClickable
        ? `
    transform: scale(1.01) translateY(-4px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);
    z-index: 1;
    background-color: ${colors.custom.table.row.hover};

    & td {
      color: ${colors.BLACK};
    }
    `
        : ''}
  }

  & .MuiTableCell-root {
    &[align='center'] {
      text-align: center;
    }
    &[align='right'] {
      text-align: right;
    }
    &[align='left'] {
      text-align: left;
    }
  }
`;
